<template>
  <div class="navBox" v-loading="loading">
    <div class="box-list">
      <h3 class="H3">请选择实验策略：</h3>
      <ul class="research_list" v-for="(item,idx) in strategy" 
      :key="idx"  :class="item.strategyNo==strategyNo?'research_hover':''"
      @click="research(item)">
        <!-- <router-link
          :name="'/experiment/'+item.strategyNo"
          :to="`/experiment/${item.strategyNo}?name=${item.strategyName}`"
        >  </router-link> -->
          <li>
            <img :src="imgUrl[idx%4]" />
            <div class="research_tit">
              <h3 class="list_name">{{item.strategyName}}</h3>
            </div>
          </li>
      </ul>
       <div class="btnTen">
        <el-button  type="primary" :disabled="strategyNo==''" @click="getNext">确定</el-button>
      </div>
    </div>
   
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      famaType:0,
      strategyNo:'',
      imgUrl: [
        require("../../assets/image/experiment1.png"),
        require("../../assets/image/experiment2.png"),
        require("../../assets/image/experiment3.png"),
        require("../../assets/image/experiment4.png"),
      ],
      strategy: [],
      strategyInit:{}
    };
  },
  methods: {
    research(item){
      this.strategyInit = item;
      this.strategyNo = item.strategyNo;
    },
    getNext(){
        this.$router.push({
          path: `/experiment/${this.strategyInit.strategyNo}?name=${this.strategyInit.strategyName}`,
        });
    },
    getStrategyList() {
      this.loading = true;
      this.$api.hubei.getStrategyList().then((res) => {
        this.loading = false;
        this.strategy = res;
        // localStorage.setItem("MENUS", JSON.stringify(res));
      });
    },
  },
  created() {
    this.getStrategyList();
  },
};
</script>
<style lang="less" scoped>
.navBox {
  
  min-height: 100%;
  height: 100%;
  // position: absolute;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // right: 0;
  // height: 100%;

}
.btnTen{
    text-align: center;
    padding-top: 30px;
}
.box-list {
   background: url("../../assets/image/banner/0.png") no-repeat center;
  background-size: 100% 100%;
    text-align: center;
    padding-top: 50px;
    min-height: 100%;
    .H3{
      margin: 0 auto;
      text-align: left;
      width: 1350px;
      font-size: 24px;
      margin-bottom: 28px;
      color: #fff;
    }
  .research_list {
    display: inline-block;
    margin: 0 15px;
    cursor: pointer;
    position: relative;
    color: #fff;
    margin-bottom: 20px;
    transition: all 1s;
    height: 387px;
    // background: #003D56;
    // box-shadow: inset 0px 0px 32px 0px rgba(63,152,241,1); // 内阴影
    // border-radius: 8px;
    img {
      height: 388px;
      border-radius: 10px;
    }
  }
  .research_list:hover{
    // box-shadow: 0px 0px 31px 0px rgba(87,163,239,1);
    transform: scale(1.1);
    // height: 387px;
  }
  .research_hover {
    transform: scale(1.1);
  }
  .research_tit {
    position: absolute;
    bottom: 0;
    width: 320px;
    height: 89px;
    text-align: center;
    line-height: 82px;
    .list_name {
      font-size: 18px;
      margin-bottom: 20px;
    }
    .list_desc {
      width: 130px;
      margin: 0 auto;
      display: -webkit-box;
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
.boxBg {
  width: 330px;
  height: 395px;
  // background: url("../../assets/image/research1.png");
}
</style>